import { Group, Title } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';

export const DeviceManagementHeader = () => {
  const { t } = useTranslation();
  return (
    <Group justify="space-between" mb={8} align="center">
      <Group gap={8} align="center">
        <Title order={4} c="gray.9">
          {t('마이페이지_기기관리_타이틀')}
        </Title>
      </Group>
    </Group>
  );
};
